{
  "allApps": "Tutte le app",
  "back": "Torna a principale",
  "myApps": "Le mie app",
  "viewMoreApps": "Visualizza altre app"
}
